var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"relative w-full h-full bg-white",style:(_vm.outerStyle)},[_c('div',{staticClass:"w-full max-w-7xl mx-auto px-8 py-8 pb-20",class:[_vm.innerClass]},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }